/* Rovina sticky add-to-cart bar */
if (!customElements.get('clone-sticky-atc')) {
  customElements.define(
    'clone-sticky-atc',
    class CloneStickyAtc extends HTMLElement {
      connectedCallback() {
        const section = this.dataset.section;
        this.mainButton = document.getElementById(`ProductSubmitButton-${section}`);
        this.button = this.querySelector('.clone-sticky-atc__button');
        // move to <body> so the fixed bar is not clipped by sticky/transformed ancestors
        if (this.parentElement !== document.body) {
          document.body.appendChild(this);
          return;
        }
        if (!this.mainButton) return;
        this.button.addEventListener('click', () => {
          if (this.dataset.action === 'scroll') {
            this.mainButton.closest('product-info, .product__info-wrapper')?.scrollIntoView({ behavior: 'smooth', block: 'start' });
            return;
          }
          this.mainButton.click();
        });
        this.observer = new IntersectionObserver(
          ([entry]) => {
            const passed = !entry.isIntersecting && entry.boundingClientRect.top < 0;
            this.classList.toggle('is-visible', passed);
            this.setAttribute('aria-hidden', String(!passed));
            this.button.tabIndex = passed ? 0 : -1;
          },
          { threshold: 0 }
        );
        this.observer.observe(this.mainButton);
        // mirror disabled / sold out state of the main button
        new MutationObserver(() => {
          this.button.disabled = this.mainButton.hasAttribute('disabled');
        }).observe(this.mainButton, { attributes: true, attributeFilter: ['disabled'] });
      }

      disconnectedCallback() {
        if (this.observer) this.observer.disconnect();
      }
    }
  );
}
